import { dataMagicWand } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMagicWand = /*#__PURE__*/createIcon(dataMagicWand)
export default IconMagicWand
